<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>

                <CCardBody>
                    <EntityTabLinks />

                    <ImportPage
                        :id="entity.id"
                        type="entity"
                        csv-import
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import to from 'await-to-js';
    import EntityTabLinks from '@/components/entities/EntityTabLinks';
    import ImportPage from '@/components/import/ImportPage';

    export default {
        components: {
            EntityTabLinks,
            ImportPage,
        },

        data: () => ({
            entity: undefined,
        }),

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = this.$route.params.id;

                const [error, result] = await to(this.axios.get(`/entities/get/${id}`));

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка загрузки сервиса.');
                }

                this.entity = result.data;
            },
        },
    };
</script>
